<template>
  <div class="content">
    <div class="container-fluid">
      <card-item>
        <div class="d-flex justify-content-end">
          <button class="btn btn-danger btn-sm" @click="volver">volver</button>
        </div>
      </card-item>
      <div class="row">
        <div class="col">
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Historial de mantenimientos</h4>
                  <p class="card-category">Listado</p>
                </div>
              </div>
            </template>
            <div class="container-fluid h-100">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="quickFilter" class="label">Filtro rapido</label>
                    <input
                      type="text"
                      class="form-control"
                      id="quickFilter"
                      v-model="quickFilter"
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="height: 100%">
                <div class="col" style="position: relative; height: 100%">
                  <ag-grid-vue
                    style="width: 100%; height: 60vh"
                    class="ag-theme-alpine"
                    :gridOptions="gridOptions"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="rowData"
                    @grid-ready="onGridReady"
                    :getContextMenuItems="getContextMenuItems"
                  >
                  </ag-grid-vue>
                </div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";

export default {
  name: "HistorialDeMantenimientos",
  mounted() {
    this.getData();
  },
  components: { AgGridVue },
  data: () => ({
    quickFilter: "",
    rowData: null,
    gridApi: null,

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },

    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      maxWidth: 100,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },

    columnDefs: [
      { headerName: "Patente", field: "patente", minWidth: 150, maxWidth: 150 },
      { headerName: "Alias", field: "alias", minWidth: 150, maxWidth: 150 },
      {
        headerName: "Fecha Inicio",
        valueGetter: (params) => {
          return moment(params.data.fecha_inicio).format("LLLL");
        },
        minWidth: 280,
        maxWidth: 300,
      },
      {
        headerName: "Fecha fin",
        valueGetter: (params) => {
          return moment(params.data.fecha_inicio).format("LLLL");
        },
        minWidth: 280,
        maxWidth: 300,
      },
      {
        headerName: "Cliente",
        field: "cliente",
        maxWidth: 200,
        minWidth: 200,
        hide: true,
      },
    ],
  }),
  methods: {
    volver() {
      this.$router.push(
        `/admin/clientes/${this.$route.params.id_cliente}/contratos`,
      );
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();
      this.getData().then(() => {
        window.api = params.api;

        this.$nextTick(() => {
          this.gridApi.hideOverlay();
        });
      });
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    async getData() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetHistorialDeMantenimientosByClienteId",
        parameters: [
          { name: "id_cliente", value: this.$route.params.id_cliente },
        ],
      });
      if (resp.data.ok) {
        this.rowData = get(resp.data, "result[0]", null);
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
  },
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
